
// import * as React from 'react';
// import PropTypes from 'prop-types';
// import { styled } from '@mui/material/styles';
// import Stack from '@mui/material/Stack';
// import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';
// import Check from '@mui/icons-material/Check';
// import SettingsIcon from '@mui/icons-material/Settings';
// import GroupAddIcon from '@mui/icons-material/GroupAdd';
// import VideoLabelIcon from '@mui/icons-material/VideoLabel';
// import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
// import { useSelector } from 'react-redux';

// const QontoConnector = styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 10,
//     left: 'calc(-50% + 16px)',
//     right: 'calc(50% + 16px)',
//   },
//   [`&.${stepConnectorClasses.active}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       borderColor: '#784af4',
//     },
//   },
//   [`&.${stepConnectorClasses.completed}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       borderColor: '#784af4',
//     },
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     borderColor: '#eaeaf0',
//     borderTopWidth: 3,
//     borderRadius: 1,
//     ...theme.applyStyles('dark', {
//       borderColor: theme.palette.grey[800],
//     }),
//   },
// }));

// const QontoStepIconRoot = styled('div')(({ theme }) => ({
//   color: '#eaeaf0',
//   display: 'flex',
//   height: 22,
//   alignItems: 'center',
//   '& .QontoStepIcon-completedIcon': {
//     color: '#784af4',
//     zIndex: 1,
//     fontSize: 18,
//   },
//   '& .QontoStepIcon-circle': {
//     width: 8,
//     height: 8,
//     borderRadius: '50%',
//     backgroundColor: 'currentColor',
//   },
//   ...theme.applyStyles('dark', {
//     color: theme.palette.grey[700],
//   }),
//   variants: [
//     {
//       props: ({ ownerState }) => ownerState.active,
//       style: {
//         color: '#784af4',
//       },
//     },
//   ],
// }));

// function QontoStepIcon(props) {
//   const { active, completed, className } = props;

//   return (
//     <QontoStepIconRoot ownerState={{ active }} className={className}>
//       {completed ? (
//         <Check className="QontoStepIcon-completedIcon" />
//       ) : (
//         <div className="QontoStepIcon-circle" />
//       )}
//     </QontoStepIconRoot>
//   );
// }

// QontoStepIcon.propTypes = {
//   /**
//    * Whether this step is active.
//    * @default false
//    */
//   active: PropTypes.bool,
//   className: PropTypes.string,
//   /**
//    * Mark the step as completed. Is passed to child components.
//    * @default false
//    */
//   completed: PropTypes.bool,
// };

// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 22,
//   },
//   [`&.${stepConnectorClasses.active}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       // backgroundImage: 'rgba(242, 102, 57, 1)',
//       backgroundImage: 'rgba(242, 102, 57, 1)',
//       // 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
//     },
//   },
//   [`&.${stepConnectorClasses.completed}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundImage: 'rgba(242, 102, 57, 1)',
//       // backgroundImage:
//       // 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
//     },
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     height: 3,
//     border: 0,
//     backgroundColor: '#F26639',
//     borderRadius: 1,
//     ...theme.applyStyles('dark', {
//       backgroundColor: theme.palette.grey[800],
//     }),
//   },
// }));


// // const ColorlibConnector = styled('div')(() => ({
// //   '& .MuiStepConnector-line': {
// //     borderColor: '#F26639', // Set the connector color to #F26639
// //   },
// // }));


// const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
//   // backgroundImage:
//   // 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)', 
//   // backgroundColor: '#ccc',

//   zIndex: 1,
//   color: '#fff',
//   width: 50,
//   height: 50,
//   display: 'flex',
//   borderRadius: '50%',
//   justifyContent: 'center',
//   alignItems: 'center',
//   ...theme.applyStyles('dark', {
//     backgroundColor: theme.palette.grey[700],
//   }),
//   variants: [
//     {
//       props: ({ ownerState }) => ownerState.active,
//       style: {
//         backgroundImage:
//           'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
//         boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
//       },
//     },
//     {
//       props: ({ ownerState }) => ownerState.completed,
//       style: {
//         backgroundImage:
//           'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
//       },
//     },
//   ],
// }));


// function ColorlibStepIcon(props) {
//   const { active, completed, className } = props;

//   const icons = {
//     1: <SettingsIcon />,
//     2: <GroupAddIcon />,
//     3: <VideoLabelIcon />,
//   };

//   return (
//     <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
//       {/* {icons[String(props.icon)]} */}
//     </ColorlibStepIconRoot>
//   );
// }

// // const ColorlibStepIcon = styled('div')(({ active }) => ({
// //   backgroundColor: active ? '#F26639' : '#F26639',

// //   // '#D3D3D3', // Active step: #F26639, Inactive: light grey
// //   borderRadius: '50%',
// //   width: 24,
// //   height: 24,
// //   display: 'flex',
// //   alignItems: 'center',
// //   justifyContent: 'center',
// // }));

// ColorlibStepIcon.propTypes = {
//   /**
//    * Whether this step is active.
//    * @default false
//    */
//   active: PropTypes.bool,
//   className: PropTypes.string,
//   /**
//    * Mark the step as completed. Is passed to child components.
//    * @default false
//    */
//   completed: PropTypes.bool,
//   /**
//    * The label displayed in the step icon.
//    */
//   icon: PropTypes.node,
// };

// const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];

// export default function TimelineExample() {
//   const state = useSelector((state) => state)

//   const StepTickets = Object.entries(state.ticketTimeLIneSlicedata.TicketTimeLinerecords);

//   const dates = StepTickets.map(([, data]) => data.created_date).filter(Boolean); // Filter out null dates
//   const statuses = StepTickets.map(([, data]) => data.status);

//   const formatDate = (dateString) => {
//     const dateObject = new Date(dateString);

//     const day = String(dateObject.getDate()).padStart(2, '0');
//     const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//     const year = dateObject.getFullYear();

//     return `${day} / ${month} / ${year}`;
//   };

//   const capitalizeEachWord = (str) => {
//     return str && typeof str === 'string'
//       ? str
//         .split(' ') // Split the string into an array of words
//         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
//         .join(' ') // Join the words back into a string
//       : ''; // Return an empty string if the input is invalid
//   };
//   // const activeStep = dates.length;
//   const activeStep = StepTickets.findIndex(([, data]) =>
//     data.created_date != null);


//   const activeSteptest = Object.entries(StepTickets).findIndex(([key, data]) => {
//     // 'data' is an array of two elements, where the second element is the object with created_date and status.
//     const stepData = data[1];  // The object containing 'created_date' and 'status'

//     console.log(stepData.created_date, "Checking created_date", stepData.status);

//     if (stepData.created_date !== null && stepData.created_date !== undefined) {
//       console.log(stepData.created_date, "Created Date for active step");
//       return true;  // Return true when we find a valid 'created_date'
//     }
//     return false;
//   });
//   console.log(activeSteptest, "activeSteptest", activeStep);
//   console.log(StepTickets, "StepTickets");


//   if (activeStep !== -1) {
//     console.log(StepTickets[activeStep][1].created_date, "Created Date for activeStep");
//   } else {
//     console.log("No active step with missing created date");
//   }

//   return (
//     <Stack sx={{ width: '100%' }} spacing={4}>
//       {/* <Stepper alternativeLabel activeStep={1} connector={<QontoConnector />}>
//         {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
//           </Step>
//         ))}
//       </Stepper> */}
//       <Stepper alternativeLabel activeStep={activeStep - 1} connector={<ColorlibConnector />}>
//         {/* {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
//           </Step>
//         ))} */}

//         {/* {dates.map((date, index) => (
//           <Step key={index}>
//             <StepLabel StepIconComponent={ColorlibStepIcon}>
//               {capitalizeEachWord(statuses[index])}
//               <p>{formatDate(date)}</p>

//             </StepLabel>
//           </Step>
//         ))} */}


//         {statuses.map((status, index) => (
//           <Step key={index}>
//             <StepLabel
//               StepIconComponent={(props) => ( //Boolean(dates[index])
//                 <ColorlibStepIcon active={dates[index] ? true : false} {...props} />
//               )}
//             >
//               <p className={`${dates[index] ? "ChartColorcontext" : "NoChartColorcontext"}`}>{capitalizeEachWord(status || 'No Status')}

//                 <br />
//                 {dates[index] ? formatDate(dates[index]) : '  '}
//               </p>
//               {/* <p className='ChartColorcontext'>{dates[index] ? formatDate(dates[index]) : '  '}</p> */}
//             </StepLabel>
//           </Step>
//         ))}


//       </Stepper>
//     </Stack>
//   );
// }


import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useSelector } from 'react-redux';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  ...theme.applyStyles('dark', {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#784af4',
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        // 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        'linear-gradient(252.44deg, #f79c37, #ef4d39)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        // 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        'linear-gradient(252.44deg, #f79c37, #ef4d39)'
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
          // 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
          'linear-gradient(252.44deg, #f79c37, #ef4d39)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
          // 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
          'linear-gradient(252.44deg, #f79c37, #ef4d39)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    // 1: <SettingsIcon />,
    // 2: <GroupAddIcon />,
    // 3: <VideoLabelIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function CustomizedSteppers() {

  const state = useSelector((state) => state)

  const StepTickets = Object.entries(state.ticketTimeLIneSlicedata.TicketTimeLinerecords);

  const dates = StepTickets.map(([, data]) => data.created_date).filter(Boolean); // Filter out null dates
  const statuses = StepTickets.map(([, data]) => data.status);

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);

    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const capitalizeEachWord = (str) => {
    return str && typeof str === 'string'
      ? str
        .split(' ') // Split the string into an array of words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
        .join(' ') // Join the words back into a string
      : ''; // Return an empty string if the input is invalid
  };
 console.log(dates ,"asdiuasdas ddates");
 


  return (
    <Stack sx={{ width: '100%' }} spacing={4}>

      {/* <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper> */}
      <Stepper alternativeLabel activeStep={dates.length -1} connector={<ColorlibConnector />}>
        {statuses.map((status, index) => { 
        console.log(status ,"status",dates);
        
        return(
          <Step key={index}>
            <StepLabel
              StepIconComponent={(props) => ( //Boolean(dates[index])
                <ColorlibStepIcon active={dates[index] ? true : false} {...props} />
              )}
            >
              <p className={`${dates[index] ? "ChartColorcontext" : "NoChartColorcontext"}`}>{capitalizeEachWord(status || 'No Status')}

                <br />
              <span className='createddatelist'>  {dates[index] ? formatDate(dates[index]) : '  '}</span>
              </p>
              {/* <p className='ChartColorcontext'>{dates[index] ? formatDate(dates[index]) : '  '}</p> */}
            </StepLabel>
          </Step>
        )})}

      </Stepper>


    </Stack >
  );
}
